import baseAPI from '@/http'

const router = 'api/acompanhamento'

export const attendanceAPI = {
  create: (attendance) => baseAPI.post(router, attendance),
  update: (attendance) => baseAPI.put(router, attendance),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: (id) => baseAPI.get(`${router}/acompanhamentos/${id}`),
  getNovo: (id) => baseAPI.get(`${router}/acompanhamentos/novo/${id}`),
  getPontosNaoEvidenciados: (id) => baseAPI.get(`${router}/acompanhamentos/pontos-nao-evidenciados/${id}`),
  finalizar: (attendance) => baseAPI.put(router + '/acompanhamentos/finalizar', attendance),
  getPontosNaoEvidenciadosTema: (id, temaId) => baseAPI.get(`${router}/acompanhamentos/pontos-nao-evidenciados/tema/${id}/${temaId}`),
  getNovoTema: (id, temaId) => baseAPI.get(`${router}/acompanhamentos/novo/tema/${id}/${temaId}`),
  finalizacao: (id) => baseAPI.get(`${router}/acompanhamentos/finalizacao/${id}`),
  cutAttendance: (payload) => baseAPI.post(router + '/acompanhamentos/acompanhamento-intermediario', payload)
}
